(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amped-collection-lineup"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('aclp-lineup')) return;

  const LEVELS = ['Beginner', 'Intermediate', 'Advanced', 'Expert'];
  const BANDS = [
    { v: 'lt10', t: 'Under 10 kW', ok: kw => kw < 10 },
    { v: '10to13', t: '10–13 kW', ok: kw => kw >= 10 && kw <= 13 },
    { v: 'gt13', t: 'Over 13 kW', ok: kw => kw > 13 },
  ];
  const SORTS = [
    { v: 'lineup', t: 'Lineup', f: (a, b) => a.order - b.order },
    { v: 'price-asc', t: 'Price, low to high', f: (a, b) => a.price - b.price },
    { v: 'price-desc', t: 'Price, high to low', f: (a, b) => b.price - a.price },
    { v: 'power', t: 'Most power', f: (a, b) => (b.power || 0) - (a.power || 0), need: 'power', spec: 'power' },
    { v: 'light', t: 'Lightest', f: (a, b) => (a.weight || 1e9) - (b.weight || 1e9), need: 'weight', spec: 'weight' },
  ];
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const num = s => { const n = parseFloat(String(s).replace(/,/g, '')); return isNaN(n) ? null : n; };
  const dollars = c => '$' + Math.round(c / 100).toLocaleString('en-US');
  const chev = '<svg viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
  const minis = n => '<span class="aclp-minis" aria-hidden="true">' + [1, 2, 3, 4].map(i => `<i class="aclp-mini${i <= n ? ' is-on' : ''}"></i>`).join('') + '</span>';

  class AclpLineup extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('[data-flt]');
      this.list = this.querySelector('.aclp__list');
      if (!this.bar || !this.list) return;
      this.items = [...this.list.querySelectorAll('.aclp__row')].map(el => {
        const d = el.dataset, power = num(d.power);
        el.querySelectorAll('.aclp__spec').forEach(s => {
          const k = (s.querySelector('dt')?.textContent || '').toLowerCase();
          s.dataset.k = k.includes('power') ? 'power' : k.includes('battery') ? 'battery' : (k.includes('weight') || k.includes('pound')) ? 'weight' : '';
        });
        return {
          el, order: +d.order, level: +d.level || 0, price: +d.price, vendor: d.vendor,
          avail: d.avail === 'true', power, weight: num(d.weight), battery: (d.battery || '').trim(),
          band: power == null ? '' : (BANDS.find(b => b.ok(power)) || {}).v,
        };
      });
      if (this.items.length < 2) return;

      const uniq = (key, order) => {
        const vals = [...new Set(this.items.map(i => i[key]).filter(v => v !== '' && v != null && v !== 0))];
        return order ? order.filter(o => vals.includes(o.v)) : vals.sort((a, b) => (num(b) === null ? 0 : num(a) - num(b)) || String(a).localeCompare(b)).map(v => ({ v, t: v }));
      };
      const g = {};
      if (this.hasAttribute('data-filters')) {
        g.level = { label: 'Rider level', chips: true, opts: uniq('level', LEVELS.map((t, i) => ({ v: i + 1, t }))), key: 'level' };
        g.vendor = { label: 'Brand', opts: uniq('vendor'), key: 'vendor' };
        g.band = { label: 'Peak power', opts: uniq('band', BANDS), key: 'band', spec: 'power' };
        g.battery = { label: 'Battery', opts: uniq('battery'), key: 'battery', spec: 'battery' };
        g.avail = { label: 'Availability', opts: [{ v: true, t: 'In stock' }, { v: false, t: 'Sold out' }].filter(o => this.items.some(i => i.avail === o.v)), key: 'avail' };
        for (const k in g) if (g[k].opts.length < 2) delete g[k];
        const prices = this.items.map(i => i.price);
        this.pRange = [Math.min(...prices), Math.max(...prices)];
        this.hasPrice = this.pRange[1] > this.pRange[0];
      }
      this.groups = g;
      this.sorts = this.hasAttribute('data-sort') ? SORTS.filter(s => !s.need || this.items.filter(i => i[s.need] != null).length > 1) : [];
      if (!Object.keys(g).length && !this.hasPrice && this.sorts.length < 2) return;

      this.state = { sort: 'lineup', pmin: '', pmax: '' };
      for (const k in g) this.state[k] = new Set();
      this.open = null;

      const sel = this.querySelector('[data-sort-sel]');
      if (this.sorts.length > 1) {
        sel.innerHTML = this.sorts.map(s => `<option value="${s.v}">${s.t}</option>`).join('');
        sel.addEventListener('change', () => { this.state.sort = sel.value; this.update(); });
        this.querySelector('[data-sort-wrap]').hidden = false;
      }
      this.sheet = this.querySelector('[data-sheet]');
      this.addEventListener('click', e => this.onClick(e));
      this.addEventListener('input', e => this.onInput(e));
      this.outside = e => { if (this.open && !e.target.closest('.aclp-dd')) { this.open = null; this.update(); } };
      this.esc = e => { if (e.key === 'Escape' && this.open) { const k = this.open; this.open = null; this.update(); this.querySelector(`[data-open="${k}"]`)?.focus(); } };
      document.addEventListener('click', this.outside);
      document.addEventListener('keydown', this.esc);
      this.sheet?.addEventListener('close', () => this.querySelector('[data-mob]')?.focus());
      this.bar.hidden = false;
      this.update();
    }
    disconnectedCallback() { if (this.outside) { document.removeEventListener('click', this.outside); document.removeEventListener('keydown', this.esc); } }

    match(i, skip) {
      for (const k in this.groups) {
        if (k === skip || !this.state[k].size) continue;
        if (!this.state[k].has(i[this.groups[k].key])) return false;
      }
      if (skip === 'price') return true;
      const { pmin, pmax } = this.state;
      return (pmin === '' || i.price >= pmin * 100) && (pmax === '' || i.price <= pmax * 100);
    }
    count(k, v) { return this.items.filter(i => this.match(i, k) && i[this.groups[k].key] === v).length; }
    priceOn() { return this.state.pmin !== '' || this.state.pmax !== ''; }

    chips(k, p) {
      return this.groups[k].opts.map(o => {
        const c = this.count(k, o.v), on = this.state[k].has(o.v);
        return `<button type="button" class="aclp-chip apdp-mono" id="${p}-${k}-${o.v}" data-tog="${k}" data-v="${esc(o.v)}" aria-pressed="${on}"${!c && !on ? ' disabled' : ''}>${minis(o.v)}${esc(o.t)} <span class="aclp-n">${c}</span></button>`;
      }).join('');
    }
    opts(k, p) {
      return this.groups[k].opts.map(o => {
        const c = this.count(k, o.v), on = this.state[k].has(o.v), off = !c && !on;
        return `<label class="aclp-opt${off ? ' is-off' : ''}"><input type="checkbox" id="${p}-${k}-${esc(o.v)}" data-tog="${k}" data-v="${esc(o.v)}"${on ? ' checked' : ''}${off ? ' disabled' : ''}>${esc(o.t)}<span class="aclp-n">${c}</span></label>`;
      }).join('');
    }
    price(p) {
      const [lo, hi] = this.pRange.map(c => Math.round(c / 100));
      return `<div class="aclp-price"><div class="aclp-price__in">
        <label for="${p}-pmin">$<input id="${p}-pmin" inputmode="numeric" autocomplete="off" data-p="pmin" placeholder="${lo.toLocaleString('en-US')}" value="${this.state.pmin}" aria-label="Minimum price"></label>
        <span class="apdp-mono aclp-n">to</span>
        <label for="${p}-pmax">$<input id="${p}-pmax" inputmode="numeric" autocomplete="off" data-p="pmax" placeholder="${hi.toLocaleString('en-US')}" value="${this.state.pmax}" aria-label="Maximum price"></label>
      </div><span class="aclp-price__hint apdp-mono">This lineup runs ${dollars(this.pRange[0])} – ${dollars(this.pRange[1])}</span></div>`;
    }
    dd(k, label, body, n) {
      const open = this.open === k;
      return `<div class="aclp-dd" data-g="${k}"><button type="button" class="aclp-dd__btn apdp-mono${n ? ' has' : ''}" id="dd-${k}" data-open="${k}" aria-expanded="${open}" aria-controls="${this.id || 'aclp'}-pop-${k}">${label}${n > 0 && k !== 'price' ? ' · ' + n : ''} ${chev}</button>` +
        (open ? `<div class="aclp-dd__pop" id="${this.id || 'aclp'}-pop-${k}">${body}<div class="aclp-pop__foot"><button type="button" class="aclp-txt apdp-mono" data-clear="${k}">Clear</button><span class="apdp-mono aclp-n">${this.results().length} bikes</span></div></div>` : '') + '</div>';
    }
    results() { return this.items.filter(i => this.match(i)).sort(this.sorts.find(s => s.v === this.state.sort)?.f || SORTS[0].f); }
    active() { let n = this.priceOn() ? 1 : 0; for (const k in this.groups) n += this.state[k].size; return n; }

    update() {
      const g = this.groups, parts = [];
      const focusId = document.activeElement && this.contains(document.activeElement) ? document.activeElement.id : null;
      if (g.level) parts.push(`<span class="aclp-flt__k apdp-mono" data-g="level">Rider level</span><div class="aclp-chips" role="group" aria-label="Filter by rider level" data-g="level">${this.chips('level', 'b')}</div>`);
      const dds = [];
      if (this.hasPrice) dds.push(this.dd('price', 'Price', this.price('d'), this.priceOn()));
      for (const k of ['vendor', 'band', 'battery', 'avail']) if (g[k]) dds.push(this.dd(k, g[k].label, this.opts(k, 'd'), this.state[k].size));
      if (parts.length && dds.length) parts.push('<span class="aclp-flt__sep" aria-hidden="true"></span>');
      this.querySelector('[data-groups]').innerHTML = parts.join('') + dds.join('');

      const r = this.results();
      this.items.forEach(i => { i.el.hidden = true; });
      r.forEach(i => { i.el.hidden = false; this.list.appendChild(i.el); });
      const none = this.querySelector('[data-none]');
      this.list.appendChild(none);
      none.hidden = r.length > 0;

      const hits = new Set();
      for (const k in g) if (g[k].spec && this.state[k].size) hits.add(g[k].spec);
      const so = SORTS.find(s => s.v === this.state.sort); if (so?.spec) hits.add(so.spec);
      this.list.querySelectorAll('.aclp__spec').forEach(s => s.classList.toggle('is-hit', hits.has(s.dataset.k)));

      this.querySelector('[data-count]').innerHTML = `<b>${r.length}</b> of ${this.items.length} bikes`;
      const pills = [];
      for (const k in g) for (const v of this.state[k]) pills.push(`<button type="button" class="aclp-pill apdp-mono" data-tog="${k}" data-v="${esc(v)}">${esc(g[k].opts.find(o => o.v === v).t)} <i aria-hidden="true">&times;</i><span class="visually-hidden"> remove filter</span></button>`);
      if (this.priceOn()) pills.push(`<button type="button" class="aclp-pill apdp-mono" data-clear="price">${this.state.pmin !== '' ? dollars(this.state.pmin * 100) : dollars(this.pRange[0])} – ${this.state.pmax !== '' ? dollars(this.state.pmax * 100) : dollars(this.pRange[1])} <i aria-hidden="true">&times;</i><span class="visually-hidden"> remove filter</span></button>`);
      const act = this.querySelector('[data-active]');
      act.hidden = !pills.length;
      act.innerHTML = pills.join('') + (pills.length > 1 ? '<button type="button" class="aclp-txt apdp-mono" data-clearall>Clear all</button>' : '');
      const n = this.active(), b = this.querySelector('[data-mob-n]');
      b.hidden = !n; b.textContent = n;
      const sel = this.querySelector('[data-sort-sel]'); if (sel) sel.value = this.state.sort;
      if (this.sheet?.open) this.renderSheet();
      if (focusId) document.getElementById(focusId)?.focus();
    }

    renderSheet() {
      const g = this.groups, out = [];
      if (this.sorts.length > 1) out.push(`<div class="aclp-grp"><p class="aclp-grp__t apdp-mono">Sort</p>${this.sorts.map(s => `<label class="aclp-opt"><input type="radio" name="${this.id || 'aclp'}-msort" id="m-sort-${s.v}" data-sortv="${s.v}"${this.state.sort === s.v ? ' checked' : ''}>${s.t}</label>`).join('')}</div>`);
      if (g.level) out.push(`<div class="aclp-grp"><p class="aclp-grp__t apdp-mono">Rider level</p><div class="aclp-chips">${this.chips('level', 'm')}</div></div>`);
      if (this.hasPrice) out.push(`<div class="aclp-grp"><p class="aclp-grp__t apdp-mono">Price</p>${this.price('m')}</div>`);
      for (const k of ['vendor', 'band', 'battery', 'avail']) if (g[k]) out.push(`<div class="aclp-grp"><p class="aclp-grp__t apdp-mono">${g[k].label}</p>${this.opts(k, 'm')}</div>`);
      this.querySelector('[data-sheet-bd]').innerHTML = out.join('');
      const n = this.results().length;
      this.querySelector('[data-go]').innerHTML = `Show ${n} bike${n === 1 ? '' : 's'} <span aria-hidden="true">&rarr;</span>`;
    }

    toggle(k, raw) {
      const o = this.groups[k].opts.find(o => String(o.v) === raw); if (!o) return;
      const s = this.state[k]; s.has(o.v) ? s.delete(o.v) : s.add(o.v);
    }
    onClick(e) {
      const t = e.target.closest('button, input'); if (!t || !this.contains(t)) return;
      const d = t.dataset;
      if (d.open) { this.open = this.open === d.open ? null : d.open; }
      else if (d.tog) { this.toggle(d.tog, d.v); }
      else if (d.sortv) { this.state.sort = d.sortv; }
      else if (d.clear) { if (d.clear === 'price') { this.state.pmin = this.state.pmax = ''; } else this.state[d.clear].clear(); }
      else if ('clearall' in d) { for (const k in this.groups) this.state[k].clear(); this.state.pmin = this.state.pmax = ''; }
      else if ('mob' in d) { this.open = null; this.renderSheet(); this.sheet.showModal(); return; }
      else if ('close' in d) { this.sheet.close(); return; }
      else return;
      this.update();
      // The control that was clicked may have been re-rendered away (a pill, the empty-state button).
      if (!this.contains(document.activeElement)) (this.sheet?.open ? this.sheet : this).querySelector('.aclp-chip, .aclp-dd__btn, .aclp-opt input, .aclp-sheet__x')?.focus();
    }
    onInput(e) {
      const k = e.target.dataset.p; if (!k) return;
      e.target.value = e.target.value.replace(/[^0-9]/g, '');
      clearTimeout(this.t);
      this.t = setTimeout(() => {
        const id = e.target.id; this.state[k] = e.target.value; this.update();
        const el = document.getElementById(id); if (el) { el.focus(); el.setSelectionRange(el.value.length, el.value.length); }
      }, 450);
    }
  }
  customElements.define('aclp-lineup', AclpLineup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amped-pdp-checklist"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bind(root) {
    if (root.dataset.apdpCarInit) return;
    root.dataset.apdpCarInit = '1';
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-apdp-slide]'));
    if (slides.length < 2) return;
    var count = root.querySelector('[data-apdp-count]');
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    }
    var prev = root.querySelector('[data-apdp-prev]');
    var next = root.querySelector('[data-apdp-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
  }
  function initAll() { document.querySelectorAll('[data-apdp-carousel]').forEach(bind); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amped-pdp-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHero(root) {
    if (root.dataset.apdpInit) return;
    root.dataset.apdpInit = '1';
    var dataEl = root.querySelector('[data-apdp-variants]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var idInput = root.querySelector('[data-apdp-variant-id]');
    var priceEl = root.querySelector('[data-apdp-price]');
    var compareEl = root.querySelector('[data-apdp-compare]');
    var saveEl = root.querySelector('[data-apdp-save]');
    var atc = root.querySelector('[data-apdp-atc]');
    var atcLabel = root.querySelector('[data-apdp-atc-label]');
    var mainImg = root.querySelector('[data-apdp-main]');
    var affirmEl = root.querySelector('[data-apdp-affirm]');
    // The Affirm app's own script (affirmShopify.js) deletes the first .affirm-as-low-as on the page
    // whenever anything in #main changes, because it only manages the one it inserts next to Focal's
    // .price--large, which this template doesn't have. So the element carries Affirm's class only while
    // Affirm renders into it; our observer (registered before the app's) strips it once text arrives.
    function affirmRender(cents) {
      if (!affirmEl || !affirmEl.isConnected) return;
      affirmEl.setAttribute('data-amount', cents);
      affirmEl.classList.add('affirm-as-low-as');
      affirm.ui.ready(function () { affirm.ui.refresh(); });
    }
    if (affirmEl) {
      new MutationObserver(function () {
        if (affirmEl.classList.contains('affirm-as-low-as') && affirmEl.textContent.trim()) {
          affirmEl.classList.remove('affirm-as-low-as');
        }
      }).observe(affirmEl, { childList: true, subtree: true });
      (function waitForAffirm(tries) {
        if (window.affirm && affirm.ui) { affirmRender(affirmEl.getAttribute('data-amount')); }
        else if (tries < 40) { setTimeout(function () { waitForAffirm(tries + 1); }, 250); }
      })(0);
    }
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-apdp-optgroup]'));
    var rail = root.querySelector('[data-apdp-rail]');
    var railWrap = root.querySelector('[data-apdp-rail-wrap]');
    var railPrev = root.querySelector('[data-apdp-rail-prev]');
    var railNext = root.querySelector('[data-apdp-rail-next]');

    function railScrollThumbIntoView(t) {
      if (!rail || !t) return;
      var rr = rail.getBoundingClientRect(), tr = t.getBoundingClientRect();
      if (tr.top < rr.top) rail.scrollTop -= (rr.top - tr.top);
      else if (tr.bottom > rr.bottom) rail.scrollTop += (tr.bottom - rr.bottom);
    }
    function updateRailNav() {
      if (!rail || !railWrap) return;
      var scrollable = rail.scrollHeight - rail.clientHeight > 2;
      railWrap.classList.toggle('is-scrollable', scrollable);
      if (!scrollable) return;
      if (railPrev) railPrev.disabled = rail.scrollTop <= 1;
      if (railNext) railNext.disabled = rail.scrollTop >= (rail.scrollHeight - rail.clientHeight - 1);
    }

    function selectedOptions() {
      var sel = [];
      groups.forEach(function (g) {
        var active = g.querySelector('.apdp-hero__swatch.is-active');
        sel[parseInt(g.dataset.optionIndex, 10)] = active ? active.dataset.value : null;
      });
      return sel;
    }

    function matchVariant(sel) {
      // No option groups means a single default-title variant, so there is
      // nothing to match on: sel is empty and every() would compare the
      // variant's "Default Title" against undefined, find nothing, and leave
      // the button stuck on "Unavailable".
      if (!groups.length) { return variants[0]; }
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      });
    }

    // mark option values that lead to no available variant given the selections
    // ABOVE them only. Judging an earlier option against a later one crossed out
    // Silver frame on the Falcon Pro whenever "All Black" graphic was picked
    // (no Silver / All Black variant exists). Picking a value instead re-points
    // the later options at an available combo (see reconcileBelow).
    function refreshAvailability(sel) {
      groups.forEach(function (g) {
        var idx = parseInt(g.dataset.optionIndex, 10);
        g.querySelectorAll('.apdp-hero__swatch').forEach(function (btn) {
          var anyAvail = variants.some(function (v) {
            return v.available && v.options.every(function (o, i) {
              return i === idx ? o === btn.dataset.value : (i > idx || sel[i] == null || o === sel[i]);
            });
          });
          btn.classList.toggle('is-unavailable', !anyAvail);
        });
      });
    }

    // after picking option idx, if the combo is missing or sold out, move the later
    // options to the first available variant that keeps options 0..idx as picked
    function reconcileBelow(idx) {
      var sel = selectedOptions();
      var cur = matchVariant(sel);
      if (cur && cur.available) return;
      var alt = variants.find(function (v) {
        return v.available && v.options.every(function (o, i) { return i > idx || o === sel[i]; });
      });
      if (!alt) return;
      groups.forEach(function (g) {
        var i = parseInt(g.dataset.optionIndex, 10);
        if (i <= idx) return;
        g.querySelectorAll('.apdp-hero__swatch').forEach(function (b) {
          b.classList.toggle('is-active', b.dataset.value === alt.options[i]);
        });
      });
    }

    function render() {
      var sel = selectedOptions();
      refreshAvailability(sel);
      groups.forEach(function (g) {
        var active = g.querySelector('.apdp-hero__swatch.is-active');
        var label = g.querySelector('[data-apdp-optvalue]');
        if (label && active) label.textContent = active.dataset.value;
      });
      var v = matchVariant(sel);
      if (!v) {
        atc.disabled = true;
        atcLabel.textContent = data.unavailLabel;
        return;
      }
      if (idInput.value !== String(v.id)) {
        idInput.value = v.id;
        // Shopify's payment_terms banner re-prices on a change event from the id input
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (affirmEl && window.affirm && affirm.ui && affirmEl.getAttribute('data-amount') !== String(v.cents)) {
        // after the app's mutation handler for this render has run, so it can't catch the class
        setTimeout(function () { affirmRender(v.cents); }, 0);
      }
      priceEl.textContent = v.price;
      if (v.compare) { compareEl.textContent = v.compare; compareEl.hidden = false; }
      else { compareEl.hidden = true; }
      if (v.savings) { saveEl.textContent = 'Save ' + v.savings; saveEl.hidden = false; }
      else { saveEl.hidden = true; }
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? data.addLabel : data.soldOutLabel;
      if (v.image && mainImg) {
        mainImg.src = v.image;
        var activeThumb = null;
        root.querySelectorAll('[data-apdp-thumb]').forEach(function (t) {
          var on = t.dataset.full === v.image;
          t.classList.toggle('is-active', on);
          if (on) activeThumb = t;
        });
        railScrollThumbIntoView(activeThumb);
      }
    }

    groups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var btn = e.target.closest('.apdp-hero__swatch');
        if (!btn) return;
        g.querySelectorAll('.apdp-hero__swatch').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        reconcileBelow(parseInt(g.dataset.optionIndex, 10));
        render();
      });
    });

    // gallery thumbnails
    root.querySelectorAll('[data-apdp-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (mainImg) mainImg.src = t.dataset.full;
        root.querySelectorAll('[data-apdp-thumb]').forEach(function (o) { o.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    // quantity
    var qty = root.querySelector('[data-apdp-qty]');
    var dec = root.querySelector('[data-apdp-qty-dec]');
    var inc = root.querySelector('[data-apdp-qty-inc]');
    if (dec) dec.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
    if (inc) inc.addEventListener('click', function () { qty.value = Math.min(9, (parseInt(qty.value, 10) || 1) + 1); });

    // thumbnail rail slider (arrows page through the overflow; arrows hide when all fit)
    if (rail) {
      var railPage = (88 + 10) * 3; // ~3 thumbnails per click
      if (railPrev) railPrev.addEventListener('click', function () { rail.scrollBy({ top: -railPage, behavior: 'smooth' }); });
      if (railNext) railNext.addEventListener('click', function () { rail.scrollBy({ top: railPage, behavior: 'smooth' }); });
      rail.addEventListener('scroll', updateRailNav);
      window.addEventListener('resize', updateRailNav);
      updateRailNav();
    }

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-apdp-hero]').forEach(initHero);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amped-pdp-trust"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTrust(root) {
    if (root.dataset.apdpTrustInit) return;
    root.dataset.apdpTrustInit = '1';
    var items = Array.prototype.slice.call(root.querySelectorAll('.apdp-trust__item'));
    if (items.length < 2) return;
    var mq = window.matchMedia('(max-width: 860px)');
    var idx = 0, timer = null;
    function show(i) { items.forEach(function (it, n) { it.classList.toggle('is-active', n === i); }); }
    function start() { if (timer) return; idx = 0; show(0); timer = setInterval(function () { idx = (idx + 1) % items.length; show(idx); }, 2800); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } items.forEach(function (it) { it.classList.remove('is-active'); }); }
    function sync() { if (mq.matches) start(); else stop(); }
    if (mq.addEventListener) mq.addEventListener('change', sync); else mq.addListener(sync);
    sync();
  }
  function initAll() { document.querySelectorAll('[data-apdp-trust]').forEach(initTrust); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amped-pdp-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bind(root) {
    if (root.dataset.apdpVideoInit) return;
    root.dataset.apdpVideoInit = '1';
    var btn = root.querySelector('[data-apdp-video-play]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var id = root.dataset.youtube;
      if (!id) return;
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
      iframe.title = 'Video';
      iframe.allow = 'autoplay; encrypted-media';
      iframe.allowFullscreen = true;
      btn.remove();
      root.appendChild(iframe);
    });
  }
  function initAll() { document.querySelectorAll('[data-apdp-video]').forEach(bind); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
